import { Store, Smartphone, Ticket, ShoppingCart, ArrowRight } from "lucide-react";
import { PALISIS_URL } from "@/lib/site";

const STEPS = [
  {
    icon: Store,
    chip: "bg-[#93cfe8]",
    title: "Buy online & save 10%",
    text: "Pick your tickets, platters or party packs in our online shop and pay securely — you save 10% instantly.",
    testid: "faq-step-1",
  },
  {
    icon: Ticket,
    chip: "bg-[#92d19a]",
    title: "Or buy at the park",
    text: "Tickets are available at the ticket office on the day — no booking needed, free entry and free parking.",
    testid: "faq-step-2",
  },
  {
    icon: Smartphone,
    chip: "bg-[#f8b818]",
    title: "Present & ride",
    text: "Show your confirmation (print or screenshot) at the ticket office and hit the track. Rides never expire.",
    testid: "faq-step-3",
  },
];

export default function PurchaseGuide() {
  return (
    <section className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:py-20" data-testid="faq-online-ticket-guide-card">
      <div className="grid items-start gap-8 lg:grid-cols-[1fr_1.4fr] lg:gap-12">
        <div>
          <p className="eyebrow">Buying is easy</p>
          <h2 className="mt-3 text-4xl leading-tight text-[#c87700] drop-shadow-[0_1px_0_rgba(122,86,0,0.6)] sm:text-5xl" style={{ fontFamily: '"Goodgirl", "Outfit", sans-serif' }}>
            HOW TO GET YOUR <span className="text-[#c87700]">TICKETS</span>
          </h2>
          <div className="mt-6 flex flex-wrap gap-3">
            <a href={PALISIS_URL} target="_blank" rel="noopener noreferrer" className="btn-gold" data-testid="guide-buy-tickets-btn">
              <ShoppingCart size={16} /> Buy online
            </a>
            <a href="/pricing" className="btn-outline" data-testid="guide-pricing-btn">
              See all prices <ArrowRight size={15} />
            </a>
          </div>
        </div>
        <div className="grid gap-4 sm:grid-cols-3">
          {STEPS.map((s, i) => (
            <div key={i} className="card-dark relative p-6" data-testid={s.testid}>
              <span className="absolute -top-3 left-5 rounded-full bg-[#f8b818] px-3 py-0.5 text-xs font-black text-[#0a0a0b]">
                STEP {i + 1}
              </span>
              <span className={`flex h-12 w-12 items-center justify-center rounded-full text-[#241c0d] shadow-[0_3px_0_rgba(122,86,0,0.55),0_8px_16px_rgba(36,28,13,0.18)] ${s.chip}`}>
                <s.icon size={24} />
              </span>
              <p className="mt-3 text-lg font-extrabold leading-snug text-[#241c0d]">{s.title}</p>
              <p className="mt-2 text-sm leading-relaxed text-[#5c5240]">{s.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
